<template>
    <div id="page-container" class="sidebar-l side-scroll header-navbar-fixed">
        <!-- Main Container -->
        <main id="main-container" style="padding-top: 0px;">
            <!-- Page Content -->
            <div class="content content-boxed">
                <slot></slot>
            </div>
            <!-- END Page Content -->
        </main>
        <!-- END Main Container -->
    </div>
</template>

<script>
    export default {
        methods: {}
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .omgbg {
    	background: url('../../assets/img/trees.jpg') no-repeat top center fixed;
	    background-size: cover;
	    margin: 0;
	    padding: 0;
	    height: 100%;
	    width: 100%;
    }
</style>



// WEBPACK FOOTER //
// published.vue?11bdd34c